import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { FullRow, Tooltip } from 'seagull';
import { routes } from '~/constants';
import { utils } from '~/utils';
import pluralize from '~/utils/pluralize';
import { invoiceStatusToColor } from './InvoicesDigestWidget';
import styles from './InvoicesDigestWidget.module.scss';
import { getDigestStatusLink, invoiceTypeToTooltip } from './InvoicesDigestWIdget.utils';
const InvoiceBar = (param)=>{
    let { invoicesDigest } = param;
    return /*#__PURE__*/ _jsx(FullRow, {
        className: styles.invoiceBarContent,
        testId: "invoices-bar",
        children: invoicesDigest.percentages().map((param)=>{
            let { type, percentage, count, amount } = param;
            const linkTo = getDigestStatusLink(routes.invoicesDashboard, type);
            return /*#__PURE__*/ _jsx(Tooltip, {
                title: /*#__PURE__*/ _jsxs("div", {
                    "data-testid": "invoice-bar-".concat(type, "-percentage-tooltip"),
                    children: [
                        utils.formatNumberWithCommas(count),
                        " ",
                        pluralize('invoice', count),
                        " totaling",
                        ' ',
                        amount.display(),
                        " ",
                        invoiceTypeToTooltip(count)[type]
                    ]
                }),
                children: /*#__PURE__*/ _jsx(NavLink, {
                    style: {
                        width: "".concat(percentage, "%"),
                        backgroundColor: invoiceStatusToColor[type]
                    },
                    to: linkTo,
                    "data-testid": "invoice-bar-".concat(type, "-percentage"),
                    className: styles.invoiceBarPercentage
                })
            }, type);
        })
    });
};
export default InvoiceBar;
